import { MenuItem } from './menu.item.model';

export interface PartnerMenuSection {
  title: string;
  items: MenuItem[];
}

export const sections: PartnerMenuSection[] = [
  {
    title: 'nav-item.operational.home',
    items: [
      { icon: 'home', name: 'nav.home', route: '/home' },
    ],
  },
  {
    title: 'nav-item.sales.title',
    items: [
      { icon: 'list', name: 'nav.contractors', route: '/contractors' },
      { icon: 'briefcase', name: 'nav.sales', route: '/partner/sales' },
    ],
  },
  {
    title: 'nav-item.system.title',
    items: [
      { icon: 'apps', name: 'general.more', route: '/partner/menu' },
    ],
  },
  {
    title: 'nav-item.support.title',
    items: [
      { icon: 'help-circle-outline', name: 'nav-item.support.help', route: '/support' },
    ],
  },
];

export const items: MenuItem[] = sections.flatMap((section) => section.items);

export const partnerMenu = {
  sections,
  items,
};
